import React from 'react'
import {Provider} from 'react-redux'

import createRootPortal from 'airship/components/RactivePortal/createRootPortal'

import LoginPage from './LoginPage'
import store from './store'

export default function init(
  el = document.getElementById('content-el')
): React.ReactElement {
  if (!el) {
    throw new Error('missing element')
  }

  return createRootPortal(
    <Provider store={store}>
      <LoginPage />
    </Provider>,
    el
  )
}
